import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { Ref, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { TCategoryProjections } from "@/types";

import { CategoryColors } from "./ProjectionsChart";

export type ProjectionsChartLegendRef = {
  highlight: (category: string | undefined) => void;
};

type ProjectionsChartLegendProps = {
  categoryProjections: TCategoryProjections;
  onHover: (category: string | undefined) => void;
  ref?: Ref<ProjectionsChartLegendRef>;
};

function ProjectionsChartLegend({
  categoryProjections,
  onHover,
  ref,
}: ProjectionsChartLegendProps) {
  const { t } = useTranslation(["categories"]);
  const [highlightedCategory, setHighlightedCategory] = useState<string>();

  useImperativeHandle(ref, () => {
    return {
      highlight(category: string | undefined) {
        setHighlightedCategory(category);
      },
    };
  }, []);

  const categories = Object.keys(categoryProjections);

  return (
    <ul className="gap-y-2xs pl-lg pr-sm grid grid-cols-3">
      {categories.map((category) => {
        const color = CategoryColors[category];

        return (
          <li
            className="gap-x-2xs p-3xs group flex cursor-default items-center"
            key={category}
            onMouseEnter={() => onHover(category)}
            onMouseLeave={() => onHover(undefined)}
          >
            <span
              className="size-3xs mt-[2px] rounded-full ring-2 ring-offset-1"
              style={
                {
                  backgroundColor: color,
                  "--tw-ring-color": `${color}60`,
                } as React.CSSProperties
              }
            />
            <Typography
              step="-2"
              className={cn(
                "text-grayscale group-hover:text-grayscale-dark",
                highlightedCategory === category && "text-grayscale-dark"
              )}
            >
              {t(`categories:${category}`)}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
}

export default ProjectionsChartLegend;
